export const ILEXCONNECT_URL = 'i-lexconnect.com';
export const TEST_SPIROTECH_URL = 'test.i-connect.spirotech.com';
export const SPIROTECH_URL = 'i-connect.spirotech.com';



// WEBPACK FOOTER //
// ./src/constants/websites.js